import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import frLocale from 'element-ui/lib/locale/lang/fr'

Vue.use(VueI18n)

const en = require('./en_US.json')
const zh = require('./zh_CN.json')
const fr = require('./fr_FR.json')

const i18n = new VueI18n({
  locale: sessionStorage.getItem('language') || 'fr_FR',
  messages:{
    en_US: {
      ...en,
      ...enLocale
    },
    zh_CN:{
      ...zh,
      ...zhLocale
    },
    fr_FR:{
      ...fr,
      ...frLocale
    }
  }
})

ElementUI.i18n((key, value) => i18n.t(key, value))

export default i18n